export default __webpack_public_path__ + "static/media/vegetariana.ff9f76d5.png";